import React, { useState } from "react"
import { DotLottieReact } from "@lottiefiles/dotlottie-react"
import { CheckCircleIcon } from "@heroicons/react/24/solid"
import Spinner from "./Spinner"

interface PaymentAnimationProps {
  type: "success" | "loading" | "terminal" | "failed"
}

type AnimationOption = {
  type: PaymentAnimationProps["type"]
  src: string
  width: number
  height: number
  loop?: boolean
  styleClass?: string
}

const animationOptions: AnimationOption[] = [
  {
    type: "success",
    src: "https://lottie.host/a6aaf708-40b1-4dda-8eb5-20c44242f6ab/hg4nYMV8ms.lottie",
    width: 300,
    height: 300,
    styleClass: "relative w-[120px] h-[120px] overflow-hidden",
  },
  {
    type: "loading",
    src: "https://lottie.host/9620b846-eca9-4d5c-aa80-2f152622ebc9/wMwUfarrJZ.lottie",
    width: 150,
    height: 150,
    loop: true,
    styleClass: "flex items-center justify-center overflow-hidden",
  },
  {
    type: "terminal",
    src: "https://lottie.host/e842fdc6-7e33-4224-a389-6d61c19b7bb0/07Lh94dFHB.lottie",
    width: 200,
    height: 200,
    loop: true,
    styleClass: "flex items-center justify-center overflow-hidden",
  },
  {
    type: "failed",
    src: "https://lottie.host/0c34c5a8-07e6-453b-b72a-d88df1d2ba50/ZeZ54nKNrP.lottie",
    width: 200,
    height: 200,
    styleClass: "relative w-[120px] h-[120px]",
  },
]

const PaymentAnimation: React.FC<PaymentAnimationProps> = ({ type }) => {
  const [error, setError] = useState(false)

  if (error) {
    return type === "success" ? <CheckCircleIcon className="w-8 h-8 text-green-500" /> : <Spinner size={5} />
  }

  const option = animationOptions.find((opt) => opt.type === type)
  if (!option) return null

  return (
    <div className={option.styleClass}>
      <DotLottieReact
        src={option.src}
        autoplay
        loop={option.loop}
        onError={() => setError(true)}
        style={{
          width: `${option.width}px`,
          height: `${option.height}px`,
          ...(option.type === "success" || option.type === "failed"
            ? {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }
            : {}),
        }}
        speed={0.8}
      />
    </div>
  )
}

export default PaymentAnimation
